import React, { useState } from 'react';
import Form from 'react-bootstrap/Form';
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';



function HerramientasAdministrativas() {
  const [selectedOption, setSelectedOption] = useState('');

  const handleOptionChange = (event) => {
    setSelectedOption(event.target.value);
  };

  const handleLinkButtonClick = () => {
    let link = '';
    if (selectedOption === '1') {link = '../Pdf/FormatoDenuncia.pdf';
  } else if (selectedOption === '2') {link = '../Pdf/CodigoConductaSEGOB.pdf';
} else if (selectedOption === '3') {link = '../Pdf/CodigoEticaSEGOB.pdf';

    }
    window.open(link, '_blank');
  };

  return (

      <Row>
        <Col>
          <Card>
            <Card.Body>
              <div style={{ maxWidth: '300px' }}>
            </div>             
             <Card.Text>Herramientas Administrativas</Card.Text>
              <Form.Select
                aria-label="Default select example"
                value={selectedOption}
                onChange={handleOptionChange}
              >
                <option>- - -</option>
                <option value="1">Formato Denuncia</option>
                <option value="2">Código de Conducta SEGOB</option>
                <option value="3">Código de Ética SEGOB</option>

              </Form.Select>
              <Button variant="primary" onClick={handleLinkButtonClick}>Ver</Button>
            </Card.Body>
          </Card>
        </Col>
      </Row>

  );
}

export default HerramientasAdministrativas;
